import React, { useEffect } from "react";
import { Layout } from "antd";
import { useMsal } from "@azure/msal-react";
import msalConfig, { msalInstance } from "../Config/msalConfig"; // adjust to your export
import { useNavigate } from "react-router-dom";

import HeaderJs from "../components/HeaderJs";
import FooterJs from "../components/FooterJs";
import { SignInButton } from "../components/AuthButton";

const { Header, Content } = Layout;

const Login = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const redirectUri = window.location.origin;
      const result = await instance.loginPopup({
        scopes: ['User.Read', 'openid', 'profile'],
        redirectUri
      });
      // set active account so entire app (including Copilot) sees this user immediately
      if (result && result.account) {
        instance.setActiveAccount(result.account); // ensures components reading useMsal() see the account immediately
      } else {
        const accounts = instance.getAllAccounts();
        if (accounts.length) instance.setActiveAccount(accounts[0]);
      }
      // redirect or update app state
      window.location.href = '/ContractSearch';
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      // User is already authenticated
      navigate("/ContractSearch");
    } else {
      // Initiate login
      handleLogin();
      return;
    }
  }, [instance, navigate]);

  return (
    <div className="SCAUX">
      {/* <Layout>
        <Header className="header">
          <HeaderJs />
        </Header>
        <Layout>
          <Content>
            <div style={{ margin: "70px" }}>
              <h1>Azure AD Login Demo</h1>
              <SignInButton />
            </div>
          </Content>
        </Layout>
        <FooterJs />
      </Layout> */}
    </div>
  );
};

export default Login;